import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as fromRoot from '@app/reducers';
import { Column } from '@app/shared/modules/smash-data-table/smash-data-table/smash-data-table.component';
import { Group } from '@app/shared/models/group';
import { Role } from '@app/shared/models/role';
import { User } from '@app/shared/models/user';
import { DialogService } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { GroupsActions } from './actions';
import { ModalAddGroupComponent } from './modals/modal-add-group/modal-add-group.component';
import { ModalDeleteGroupComponent } from './modals/modal-delete-group/modal-delete-group.component';
import * as fromGroups from './reducers/groups.reducer';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit, OnDestroy {

  members$: Observable<User[]>;
  roles$: Observable<Role[]>;

  groups$: Observable<any[]>;
  groupsLoading$: Observable<boolean>;
  groupsLoaded$: Observable<boolean>;

  columnsEnabled: Column[] = [
    { id: 'name', colName: 'PREMIUM_ADMIN_GROUPS_TABLE_LABEL_NAME', type: 'string', removable: false, searchable: true },
    {
      id: 'provisioned', colName: 'PREMIUM_ADMIN_GROUPS_TABLE_LABEL_PROVISIONED', type: 'boolean', removable: false,
      translations: {
        true: 'PREMIUM_ADMIN_GROUPS_TABLE_LABEL_GROUP_PROVISIONED',
        false: 'PREMIUM_ADMIN_GROUPS_TABLE_LABEL_GROUP_CUSTOM',
      },
      default: 'PREMIUM_ADMIN_GROUPS_TABLE_LABEL_GROUP_CUSTOM'
    },
  ];
  subscriptions: Subscription[] = [];
  selectedGroup: Group;
  search: any;
  teamId: string;

  constructor(
    private store$: Store<fromRoot.State & fromGroups.State>,
    private router: Router,
    private dialog: DialogService,
    private route: ActivatedRoute
  ) {
    this.refreshGroups();
    this.store$.dispatch(GroupsActions.LoadAttributableRoles({ teamId: this.teamId }));

    this.groups$ = this.store$.select(fromGroups.getGroups);
    this.groupsLoading$ = this.store$.select(fromGroups.getGroupsLoading);
    this.groupsLoaded$ = this.store$.select(fromGroups.getGroupsLoaded);
  }

  ngOnInit(): void { }

  goToDetails(groupId: string) {
    this.route.params.pipe(take(1)).subscribe(({ id }) => {
      this.router.navigateByUrl('/account/team/' + id + '/groups/' + groupId);
    });
  }

  refreshGroups() {
    this.route.params.pipe(take(1)).subscribe(({ id }) => {
      this.teamId = id;
      this.store$.dispatch(GroupsActions.LoadGroups({ teamId: this.teamId }));
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  async openModalAddGroup() {
    this.dialog.open(ModalAddGroupComponent, {
      enableClose: false,
      closeButton: false,
      size: 'sm',
      data: {
        teamId: this.teamId,
      }
    });
  }

  openModalDeleteGroup(group) {
    this.dialog.open(ModalDeleteGroupComponent, {
      enableClose: true,
      closeButton: false,
      size: 'sm',
      data: {
        teamId: this.teamId,
        group,
      }
    });
  }

}
